import(/* webpackMode: "eager" */ "/workspace/src/app/events/2024techfes/hackathon/page.tsx");
